import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { ICustomer } from '../../../../../store/ducks/customers/types';
import { loadCustomerPurchaseReceivers } from '../../../../../store/ducks/customers/actions';

interface IEmitterAndReceiver {
  emitterSelected: ICustomer;
  receiverSelected: ICustomer;
}

const useGetSenderAndReceiverDetails = (): IEmitterAndReceiver => {
  const dispatch = useDispatch();

  const customersData = useSelector(
    (state: ApplicationState) => state.customers
  );

  const { emitterId, receiverId } = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const emitterSelected = customersData.customers.find(
    (customer) => customer.customerId === emitterId
  );

  const sameBP = emitterId === receiverId;

  const customerReceiverSelected = sameBP
    ? emitterSelected
    : customersData.customers.find(
        (customer) => customer.customerId === receiverId
      );

  const addressFieldsAreFilledIn = (customer: ICustomer | undefined) =>
    !!(
      customer?.name &&
      customer?.locality.address &&
      customer?.locality.city &&
      customer?.customerId &&
      customer?.locality.state &&
      customer?.taxNumber &&
      customer?.locality.zipCode
    );

  const addressEmitter = addressFieldsAreFilledIn(emitterSelected);
  const addressReceiver = sameBP
    ? addressEmitter
    : addressFieldsAreFilledIn(customerReceiverSelected);

  if (emitterSelected && addressEmitter && addressReceiver) {
    return {
      emitterSelected,
      receiverSelected: customerReceiverSelected!
    };
  } else {
    const receiverSelected = emitterSelected?.purchaseReceivers?.find(
      (purchaveReceiver) => purchaveReceiver.code === receiverId
    );

    const emitterPurchaseSelected = sameBP
      ? receiverSelected
      : emitterSelected?.purchaseReceivers?.find(
          (purchaveReceiver) => purchaveReceiver.code === emitterId
        );

    const loadPurchaseReceiversIfNeed = (customer: ICustomer) => {
      if (
        customer.customerId &&
        !receiverSelected &&
        !customersData.loadingPurchaseReceivers &&
        !customersData.errorPurchaseReceivers
      ) {
        dispatch(loadCustomerPurchaseReceivers(customer.customerId));
      }
    };

    if (
      emitterSelected &&
      !customersData.loadingPurchaseReceivers &&
      !customersData.errorPurchaseReceivers &&
      !emitterSelected.purchaseReceivers
    ) {
      loadPurchaseReceiversIfNeed(emitterSelected);
    }
    return {
      emitterSelected:
        addressEmitter && emitterSelected
          ? emitterSelected
          : {
              ...emitterSelected!,
              locality: {
                address: emitterPurchaseSelected?.address ?? '',
                state: emitterPurchaseSelected?.state ?? '',
                city: emitterPurchaseSelected?.city ?? '',
                zipCode: emitterPurchaseSelected?.zipCode ?? '',
                country: '',
                district: '',
                zipcode: ''
              }
            },
      receiverSelected:
        addressReceiver && customerReceiverSelected
          ? customerReceiverSelected
          : {
              ...customerReceiverSelected!,
              locality: {
                address: receiverSelected?.address ?? '',
                state: receiverSelected?.state ?? '',
                city: receiverSelected?.city ?? '',
                zipCode: receiverSelected?.zipCode ?? '',
                country: '',
                district: '',
                zipcode: ''
              }
            }
    };
  }
};

export default useGetSenderAndReceiverDetails;
